<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";

export default {
  metaInfo: function() {
    return {
      title: "Login - Find Your Dream Job - job4u.pk",
      meta: [
        {
          name: "description",
          content:
            "Find your dream and latest Jobs in Pakistan from top recruiters, employers and companies in all over the Pakistan. Search and apply online now",
        },
      ],
    };
  },
  data() {
    return {
      // isCondensed: false,
      apiUrl: API_URL,
      auth: localStorage.getItem("id_token") !== null ? true : false,
      recruiter:
        localStorage.getItem("user") !== null &&
        JSON.parse(localStorage.getItem("user")).role == "Direct Employer"
          ? true
          : false,
      jobSeeker:
        localStorage.getItem("user") !== null &&
        JSON.parse(localStorage.getItem("user")).role == "Job Seeker"
          ? true
          : false,
      isCondensed: false,
    };
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
  },
  methods: {
    toggleMenu_barger() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },
  },
};
</script>

<template>
  <div class="mt-17">
    <div>
      <!-- Navbar STart -->
      <Navbar />
    </div>
    <div class="login_image_bg">
      <div class="container" style="margin: 0 auto">
        <div
          class="login login-1"
          :class="{
            'login-signin-on': this.state == 'signin',
            'login-signup-on': this.state == 'signup',
            'login-forgot-on': this.state == 'forgot',
          }"
          id="kt_login"
        >
          <div class="row align-items-center">
            <!--begin::Aside-->
            <div class="col-lg-4 auth_heading">
              Welcome <span class="font-weight-bolder"> Back..!</span>
            </div>
            <!--begin::Aside-->
            <!--begin::Content-->
            <div class="col-lg-5 col-md-6 bg-white p-9 px-10 border Small">
              <div class="">
                <div class="">
                  <!--begin::Signin-->
                  <div class="login-form login-signin">
                    <form
                      class="form"
                      novalidate="novalidate"
                      id="kt_login_signin_form"
                      @submit.stop.prevent="onSubmitLogin()"
                    >
                      <div class="pt-lg-0 pt-5">
                        <div class="card-title auth_title">
                          Login to your account
                        </div>
                      </div>
                      <div class="form-group">
                        <div
                          id="example-input-group-1"
                          label=""
                          label-for="example-input-1"
                          class="form-group auth_inputs_img position-relative"
                        >
                          <img
                            src="/images/login_contact/usernameemail.svg"
                            alt=""
                          />
                          <input
                            class="form-control fieldch"
                            type="text"
                            name="email"
                            placeholder="Enter Email Adderss"
                            ref="email"
                            v-model="form.email"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <div
                          id="example-input-group-2"
                          label-for="example-input-2"
                          class="form-group auth_inputs_img position-relative"
                        >
                          <img
                            src="/images/login_contact/password.svg"
                            alt=""
                          />
                          <input
                            class="form-control fieldch"
                            name="password"
                            placeholder="Enter Password"
                            ref="password"
                            v-model="form.password"
                            autocomplete="off"
                            :type="showPassword === false ? 'text' : 'password'"
                          />
                          <span
                            @click="toggleShow"
                            class="icon is-small is-right password_show_ch"
                          >
                            <i
                              :class="
                                showPassword === false
                                  ? 'fas fa-eye-slash'
                                  : 'fas fa-eye'
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <label
                            class="checkbox mb-0 col-lg-6 col-6 p-smm-0"
                            style="color: #3f4254 !important"
                          >
                            <input type="checkbox" name="agree" />
                            <span class="mr-2"> </span>
                            Remember me
                          </label>
                          <p
                            class="col-lg-6 col-6 text-right forgot-txt p-smm-0"
                          >
                            <a
                              class="test-muted"
                              id="kt_login_forgot"
                              style="color: #3f4254 !important; font-size: 12px"
                              href="/forgot"
                              >Forgot Password ?</a
                            >
                          </p>
                        </div>
                      </div>
                      <div class="pb-lg-0 pb-5">
                        <button
                          ref="kt_login_signin_submit"
                          class="btn submitBnt"
                        >
                          Sign In
                        </button>
                        <div class="row">
                          <div class="text-center pt-7" style="font-size: 12px">
                            or login with your social network
                          </div>
                          <button
                            type="button"
                            class="col-lg-12 col-12"
                            @click="authProvider('google')"
                          >
                            <img
                              class="soicail_img"
                              src="/images/login_contact/Google.svg"
                              alt=""
                            />
                          </button>
                        </div>
                      </div>
                      <div class="hr_blue"></div>
                      <div
                        class="text-muted text-center"
                        style="font-size: 13px !important"
                      >
                        Not a member?
                        <a
                          id=""
                          class="text-primary font-weight-bolder"
                          href="/job-seeker-register"
                          >Sign up</a
                        >
                      </div>
                    </form>
                  </div>
                </div>
                <!--begin::Content footer-->
                <div class="text-center pt-8">
                  <a
                    href="/terms-and-conditions"
                    class="font-weight-bold font-size-h6"
                    >Terms</a
                  >
                  <a
                    href="/recruiter"
                    class="ml-10 font-weight-bold font-size-h6"
                    >Plans</a
                  >
                  <a
                    href="/contact-us"
                    class="ml-10 font-weight-bold font-size-h6"
                    >Contact Us</a
                  >
                </div>
                <!--end::Content footer-->
              </div>
            </div>
            <!--end::Content-->
          </div>
        </div>
      </div>
    </div>
    <!--end header-->
    <!-- Navbar End -->
    <Footer />
    <Switcher />
    <!-- Back to top -->
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import Navbar from "@/view/front/components/navbar";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import { initFbsdk } from "@/core/config/facebook.js";

export default {
  name: "login-1",
  data() {
    return {
      recruiterSignUp: false,
      agencySignUp: false,
      state: "signin",
      // auth: localStorage.getItem("id_token") !== null ? true : false,
      // Remove this dummy login info

      form: {
        email: "",
        password: "",
      },
      cities: [],
      apiUrl: API_URL,
      mediaUrl: MEDIA_URL,
      recruiter:
        localStorage.getItem("user") !== null &&
        JSON.parse(localStorage.getItem("user")).role == "Direct Employer"
          ? true
          : false,
      jobSeeker:
        localStorage.getItem("user") !== null &&
        JSON.parse(localStorage.getItem("user")).role == "Job Seeker"
          ? true
          : false,
      token: `Bearer ${localStorage.getItem("token")}`,
      showPassword: true,
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
  },
  mounted() {
    // if (this.recruiter == true) {
    //   window.location.href = "/dashboard";
    // }
    // if (this.jobSeeker == true) {
    //   window.location.href = "/dashboard";
    // }
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    if (window.location.href.indexOf("register") !== -1) {
      this.showForm("signup");
    }
    if (window.location.href.indexOf("forgot") !== -1) {
      this.showForm("forgot");
    }

    axios.get(`${this.apiUrl}/get-top-job-cities`).then((response) => {
      this.cities = response.data;
    });

    initFbsdk();
    const signin_form = KTUtil.getById("kt_login_signin_form");
    const forgot_form = KTUtil.getById("kt_login_forgot_form");

    this.fv1 = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv2 = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });
  },
  components: {
    Navbar,
    Switcher,
    Footer,
  },
  methods: {
    // async login() {
    //   const GoogleUser
    // },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name)
        // "animate__animated animate__backInUp"
      );
    },

    onSubmitLogin() {
      this.fv1.validate();
      this.fv1.validate().then((res) => {
        if (res == "Valid") {
          var email = this.form.email;
          var password = this.form.password;
          this.$store.dispatch(LOGOUT);
          const submitButton = this.$refs["kt_login_signin_submit"];
          submitButton.classList.add(
            "spinner",
            "spinner-light",
            "spinner-right"
          );

          // dummy delay
          setTimeout(() => {
            // send login request
            this.$store
              .dispatch(LOGIN, { email, password })
              // go to which page after successfully login

              .then((res) => {
                localStorage.setItem("user", JSON.stringify(res.user));
                localStorage.setItem("token", res.user.token);
                /////////////////////////////////////////////////////////
                if (res.user.role == "Direct Employer") {
                  localStorage.setItem(
                    "pic",
                    JSON.stringify(res.profile.profile_pic)
                  );
                  localStorage.setItem("profile", JSON.stringify(res.profile));
                } else {
                  localStorage.setItem(
                    "pic",
                    JSON.stringify(res.profile.profile_pic)
                  );
                  localStorage.setItem("profile", JSON.stringify(res.profile));
                }
                /////////////////////////////////////////////////////////
                var jobSesstion = JSON.parse(
                  sessionStorage.getItem("jobSesstion")
                );
                if (jobSesstion) {
                  window.location.href =
                    "/jobs-careers/pakistan/" +
                    jobSesstion.city +
                    "/" +
                    jobSesstion.title +
                    "/" +
                    jobSesstion.id;
                } else {
                  window.location.href = "/dashboard";
                }
              });
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
          }, 1000);
        } else {
          Swal.fire({
            title: "",
            text: "Please, provide correct data!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        }
      });

      // console.log("login hit ht"),
      this.fv.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });
    },
   authProvider(provider) {
    axios.post('social/'+provider).then(response => {
          window.location.href = response.data
        }).catch(err => {
            console.log({err:err})
            // https://api.job4u.pk
        })
    },
    // loginWithGoogle() {
    //   console.log("GoogleUser secend");
    //   this.$gAuth
    //     .signIn()
    //     .then((GoogleUser) => {
    //       var profile = GoogleUser.getBasicProfile();
    //       axios
    //         .post(`${API_URL}/social-login`, {
    //           loginType: "google",
    //           google: GoogleUser,
    //           email: profile.getEmail(),
    //           name: profile.getName(),
    //         })
    //         .then((res) => {
    //           localStorage.setItem("user", JSON.stringify(res.data));
    //           localStorage.setItem("token", res.data.token);
    //           localStorage.setItem("id_token", res.data.token);
    //           // this.$router.push({ name: "dashboard" });
    //           window.location.href = "/dashboard";
    //         });
    //     })
    //     .catch((error) => {
    //       console.log("error", error);
    //     });
    // },

    // loginWithFacebook() {
    //   window.FB.login((response) => {
    //     var userInfo = {
    //       loginType: "fb",
    //       fb: response,
    //     };
    //     this.$store.commit("setLoginUser", userInfo);
    //     router.push("/home");
    //     z;
    //   }, this.params);
    // },
  },
};
</script>
<style scoped>
footer span,
footer a,
footer p,
footer h4,
footer label {
  color: white !important;
}
</style>
